
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","viewBox":"0 0 18 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.667 0c.46 0 .833.373.833.833v.834h5V.833a.833.833 0 011.666 0v.834h1.667a2.5 2.5 0 012.5 2.5v11.666a2.5 2.5 0 01-2.5 2.5H3.167a2.5 2.5 0 01-2.5-2.5V4.167a2.5 2.5 0 012.5-2.5h1.666V.833c0-.46.373-.833.833-.833zm-.834 3.333H3.166a.833.833 0 00-.833.834v2.5h13.334v-2.5a.833.833 0 00-.834-.834h-1.667v.834a.833.833 0 01-1.666 0v-.834h-5v.834a.833.833 0 01-1.667 0v-.834zm10.834 5H2.332v7.5c0 .46.373.834.833.834h11.667c.46 0 .833-.373.833-.834v-7.5z","fill":"#3581F3"}})])
          )
        }
      }
    